export var SET_QUESTIONS = 'SET_QUESTIONS';
export var SET_INDEX = 'SET_INDEX';
export var SET_ANSWER = 'SET_ANSWER';
export var RESET_ANSWERS = 'RESET_ANSWERS';
export var setQuestions = function (questions) { return ({
    type: SET_QUESTIONS,
    questions: questions
}); };
export var setIndex = function (index) { return ({
    type: SET_INDEX,
    index: index
}); };
export var setAnswer = function (answer) { return ({
    type: SET_ANSWER,
    answer: answer
}); };
export var resetAnswers = function () { return ({
    type: RESET_ANSWERS
}); };
//# sourceMappingURL=questionnaire.js.map